import { render, staticRenderFns } from "./AccountsTypeForm.vue?vue&type=template&id=551ef206&scoped=true"
import script from "./AccountsTypeForm.vue?vue&type=script&lang=ts"
export * from "./AccountsTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ef206",
  null
  
)

export default component.exports